<template>
  <div :class="{ processing }">
    <profile-fields></profile-fields>

    <call-to-action
      @click.native="save()"
      :processing="processing"
      v-text="translations.createAccount"
    ></call-to-action>

    <error-notification></error-notification>
  </div>
</template>

<script>
import { get } from "lodash";
import { api } from "../utils";
import ActsAsProfileForm from "../mixins/ActsAsProfileForm";
import HasTranslatedText from "../mixins/HasTranslatedText";

export default {
  mixins: [ActsAsProfileForm, HasTranslatedText],

  methods: {
    async persist(payload) {
      await api.post("user", payload);
    },

    handleSuccessfulSave() {
      window.location = get(window, "vueBridge.links.consentForm", "/user-consent-form");
    },
  },
};
</script>
